import { getConfigAtPath } from "@/_services/userConfiguration"
import moment from "moment-timezone"
import React from "react"
import { ControlLabel } from "react-bootstrap"
import Datetime from "@basikon2/react-datetime"
import FormInput from "./FormInput"

class FormInputDatetime extends React.Component {
  constructor(props) {
    super(props)
    const { timeFormat, value } = props

    this.state = {
      timeFormat: timeFormat === true ? "HH:mm" : timeFormat,
      value: this.sanitizeValue(value),
    }
  }

  // Value is sometimes false, sometimes "", sometimes a moment, sometimes a datetime. Either make it either a datetime or false.
  sanitizeValue(value) {
    let valueSanitize = value ? value : false
    return valueSanitize._isAMomentObject && valueSanitize.isValid() ? valueSanitize.toDate() : valueSanitize
  }

  componentDidUpdate(prevProps) {
    const { value, timeFormat } = this.props

    if (timeFormat !== prevProps.timeFormat || value !== prevProps.value) {
      this.setState({
        timeFormat: timeFormat === true ? "HH:mm" : timeFormat,
        value: this.sanitizeValue(value),
      })
    }
  }

  handleHourChange = timeValue => {
    const { value, timeFormat } = this.state
    const { onChange, timeZone } = this.props
    const useDateNoTime = getConfigAtPath("useDateNoTime")

    // If the value doesn't match the intended format, do not update the datetime as it will break and let the user finish his typing
    const date = !useDateNoTime && timeZone ? moment(timeValue, timeFormat, true).tz(timeZone) : moment(timeValue, timeFormat, true)
    if (date.isValid()) {
      const newDate = !useDateNoTime && timeZone ? moment(value).tz(timeZone).clone() : moment(value).clone()
      newDate.hour(moment(timeValue, timeFormat).hour())
      newDate.minute(moment(timeValue, timeFormat).minute())

      onChange(newDate)
    }
  }

  render() {
    const { value, timeFormat } = this.state
    const { splitTimeControl, inputProps, ControlLabelWithDebugWithAudit, timeZone } = this.props
    const useDateNoTime = getConfigAtPath("useDateNoTime")

    if (splitTimeControl) {
      return (
        <>
          <div className="form-input-datetime">
            <div>
              <ControlLabelWithDebugWithAudit />
              <Datetime {...this.props} timeFormat={false} displayTimeZone={!useDateNoTime ? timeZone : undefined} />
            </div>
            <TimeSelect
              label={splitTimeControl.label || " "}
              timeFormat={timeFormat}
              onChange={this.handleHourChange}
              value={value ? (!useDateNoTime && timeZone ? moment(value).tz(timeZone).format(timeFormat) : moment(value).format(timeFormat)) : false}
              interval={splitTimeControl?.minutesInterval || 30}
              timeSlots={splitTimeControl?.timeSlots || []}
              creatable={splitTimeControl?.creatable || false}
              timeZone={timeZone}
            />
          </div>
        </>
      )
    }

    return (
      <Datetime
        {...this.props}
        inputProps={{ ...inputProps, placeholder: `${inputProps.placeholder} ${timeFormat}` }}
        displayTimeZone={!useDateNoTime ? timeZone : undefined}
      />
    )
  }
}

export default FormInputDatetime

class TimeSelect extends React.Component {
  constructor(props) {
    super(props)
    const { value, interval, timeSlots } = props

    this.state = {
      value,
      interval,
      timeSlots,
    }
  }

  componentDidUpdate(prevProps) {
    const { value, interval, timeSlots } = this.props

    if (value !== prevProps.value || interval !== prevProps.interval || timeSlots !== prevProps.timeSlots)
      this.setState({ value, interval, timeSlots })
  }

  allHours = () => {
    const { value, interval, timeSlots } = this.state
    const { timeFormat, timeZone } = this.props
    const hasTimeZone = !getConfigAtPath("useDateNoTime") && timeZone
    if (value === false) return []

    const options = []
    const endOfDay = hasTimeZone ? moment().tz(timeZone).endOf("day") : moment().endOf("day")
    const currentTime = hasTimeZone ? moment().tz(timeZone).startOf("day") : moment().startOf("day")
    while (currentTime.isBefore(endOfDay)) {
      // Check if the current time is within any of the provided time slots
      if (
        !timeSlots ||
        !timeSlots.length ||
        timeSlots.some(slot =>
          currentTime.isBetween(
            hasTimeZone ? moment.tz(slot.from, timeFormat, timeZone) : moment(slot.from, timeFormat),
            hasTimeZone ? moment.tz(slot.to, timeFormat, timeZone) : moment(slot.to, timeFormat),
            null,
            "[]",
          ),
        )
      ) {
        const option = currentTime.format(timeFormat)
        options.push({ value: option, label: option })
      }
      currentTime.add(interval, "minutes")
    }
    return options
  }

  handleChange = newValue => {
    const { onChange, timeFormat, timeZone } = this.props
    const { timeSlots } = this.state
    const newHour = newValue?.value
    const hasTimeZone = !getConfigAtPath("useDateNoTime") && timeZone
    if (newHour) {
      const newHourMoment = hasTimeZone ? moment(newHour, timeFormat).tz(timeZone) : moment(newHour, timeFormat)
      // If the new value has been manually typed, check if it is a valid hour according to the used timeformat,
      // and also verify if it is within the provided time slots.
      if (
        newHourMoment._isValid &&
        (!timeSlots?.length ||
          timeSlots.some(slot =>
            newHourMoment.isBetween(
              hasTimeZone ? moment(slot.from, timeFormat).tz(timeZone) : moment(slot.from, timeFormat),
              hasTimeZone ? moment(slot.to, timeFormat).tz(timeZone) : moment(slot.to, timeFormat),
              null,
              "[]",
            ),
          ))
      ) {
        onChange(newHour)
        this.setState({ value: newHour })
      }
    }
  }

  render() {
    const { value } = this.state
    const { creatable, label } = this.props

    return (
      <div>
        <ControlLabel>{label}</ControlLabel>
        <FormInput onSelect={this.handleChange} creatable={creatable} select={this.allHours()} obj={{ value }} field="value" label="" />
      </div>
    )
  }
}
